import { Component, Inject, OnInit } from '@angular/core';
import { DialogProps } from './order-status-confirm.types';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductCodeService } from 'src/app/core/services/product-code.service';

@Component({
  selector: 'app-order-status-confirm',
  templateUrl: './order-status-confirm.component.html',
  styleUrls: ['./order-status-confirm.component.scss'],
})
export class OrderStatusConfirmComponent {

  constructor(
    public dialogRef: MatDialogRef<OrderStatusConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogProps,
    public productCode: ProductCodeService
  ) {}

  close() {
    this.dialogRef.close();
  }

  /** Mirrors the new value back into the dialog data and notifies the caller so it can persist it. */
  onCheckboxToggle(checked: boolean) {
    if (!this.data.checkbox) {
      return;
    }
    this.data.checkbox.checked = checked;
    this.data.checkbox.onToggle(checked);
  }
}
